export default __webpack_public_path__ + "static/media/carosello4.cc960779.png";